import { render } from "./Message.vue?vue&type=template&id=3f9b4675"
import script from "./Message.vue?vue&type=script&lang=ts"
export * from "./Message.vue?vue&type=script&lang=ts"
script.render = render

export default script